import styled from 'styled-components'
import { Input as BootstrapInput } from 'reactstrap'

interface InputAreaProps {
  type: string
}
export const InputArea = styled.div<InputAreaProps>`
  & .form-control.is-invalid,
  .was-validated .form-control:invalid {
    background-image: none !important;
  }

  & input,
  & textarea {
    border-radius: 15px;
    width: 100%;
  }

  & input[type='text'] {
  }
  & input[type='date'] {
  }
  & input[type='time'] {
  }
  & input[type='color'] {
    height: 38px;
  }
  & input[type='checkbox'].checkbox-roxo {
    align-items: center;
    background: transparent;
    border: var(--roxo-riber) solid 2px;
    border-radius: 5px;
    content: '';
    display: flex;
    height: 25px;
    justify-content: center;
    margin: 0;
    width: 25px;
    &:checked:after {
      align-items: center;
      background-color: var(--roxo-riber);
      border-radius: 2px;
      content: '';
      display: flex;
      height: 15px;
      justify-content: center;
      width: 15px;
    }
  }
`

export const Wrapper = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
`

export const InputWrapper = styled.div`
  position: relative;
  border: 1px solid #e5e5ea;
  border-radius: 8px;
  width: 100%;
`

export const StyledTextarea = styled(BootstrapInput).attrs({
  type: 'textarea'
})<{ isInvalid: boolean }>`
  padding: 12px;
  height: 220px !important;
  max-height: 220px;
  line-height: 1.5;
  width: 100%;
  box-sizing: border-box;
  resize: none;
  background-color: #f9f9f9;
  border: ${({ isInvalid }) =>
    isInvalid ? '1px solid #ff4d4f' : '1px solid #d9d9d9'};
  border-radius: 8px;
  color: #333;
  font-size: 16px;

  overflow-y: auto;
  white-space: pre-wrap;
  word-wrap: break-word;

  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    background: #e0e0e0;
    border-radius: 3px;
  }

  ::-webkit-scrollbar-thumb {
    background: #b0b0b0;
    border-radius: 3px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #888;
  }

  &::placeholder {
    color: #a0a0a0;
  }

  &:focus {
    outline: none;
    border-color: #80bdff;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.2);
  }
`
export const StyledInput = styled(BootstrapInput)<{ isInvalid: boolean }>`
  padding: 10px;
  height: 80px;
  line-height: normal;
  width: 100%;
  box-sizing: border-box;
  border: ${({ isInvalid }) =>
    isInvalid ? '1px solid red' : '1px solid #ced4da'};
  border-radius: 4px;
  background-color: white;

  white-space: normal;
  word-break: break-word;

  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  &::placeholder {
    color: #6c757d;
  }

  &:focus {
    outline: none;
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
`

export const Dropdown = styled.div`
  position: absolute;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  max-height: 300px;
  overflow-y: auto;
  max-width: 400px;
  right: 0;
  padding: 20px;
`

export const IconButtonWrapper = styled.div`
  position: absolute;
  bottom: 20px;
  right: 1px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
`

export const VariableContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
`

export const SearchInput = styled(BootstrapInput)`
  margin-bottom: 16px;
`

export const VariableItem = styled.div<{ isLast: boolean }>`
  display: flex;
  gap: 10px;
  cursor: pointer;
  justify-content: start;
  ${({ isLast }) => !isLast && 'margin-bottom: 12px;'}
`

export const HighlightedText = styled.span`
  color: #007bff;
`

export interface TimeInputProps {
  label: string
  value: number
  onChange: (value: number) => void
  disabled?: boolean
  invalid?: boolean
}

export const TimeInputContainer = styled.div`
  position: relative;
  width: 100%;
`

export const TimeLabel = styled.label`
  display: block;
  margin-bottom: 6px;
  font-weight: 600;
  font-size: 14px;
`

export const TimeInputBox = styled.div<{
  disabled?: boolean
  invalid?: boolean
}>`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid ${(props) => (props.invalid ? '#e74c3c' : '#dce1e6')};
  border-radius: 18px;
  display: flex;
  align-items: center;
  background-color: ${(props) => (props.disabled ? '#f5f5f5' : 'white')};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'text')};
  transition: border-color 0.2s ease-in-out;

  &:hover {
    border-color: ${(props) =>
      !props.disabled && !props.invalid ? '#aeb7c2' : ''};
  }

  input {
    background: transparent;
    border: none;
    outline: none;
    width: 100%;
    font-size: 14px;
    color: #000;
    padding: 0;
    font-family: inherit;
    background: transparent;
    border: none;
    outline: none;
    width: 100%;

    &::placeholder {
      color: #aaa;
    }
  }
`

export const ClockIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  margin-left: 8px;
  color: #333;
`

export const TimeDropdown = styled.div`
  position: absolute;
  top: 100%;
  width: 100%;
  margin-top: 4px;
  display: flex;
  border: 1px solid #ccc;
  border-radius: 10px;
  background: white;
  z-index: 1000;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
`

export const TimeColumn = styled.div`
  flex: 1;
  min-width: 50px;
  max-height: 200px;
  overflow-y: auto;

  scrollbar-width: thin;
  scrollbar-color: #ccc transparent;

  &::-webkit-scrollbar {
    width: 1px;
    height: 1px;
    scrollbar-color: #ccc transparent;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 3px;
  }
`

export const TimeOption = styled.div<{ selected?: boolean }>`
  padding: 8px;
  text-align: center;
  cursor: pointer;
  background-color: ${(props) => (props.selected ? '#e0f7fa' : 'transparent')};
  font-weight: ${(props) => (props.selected ? 'bold' : 'normal')};
  transition: background 0.2s ease-in-out;

  &:hover {
    background-color: #f0f0f0;
  }
`
